import React, { useState } from 'react';
import styled from 'styled-components';
import { Collapse, Typography, Input, Button } from "antd";
import { SearchOutlined, WhatsAppOutlined } from '@ant-design/icons';
import SubBanner from "../components/SubBanner";
import ContentContainer from "../components/ContentContainer";
import Section from "../components/Section";
import PaginatedList from "../components/PaginatedList";
import { GREE_1 } from "../utils/colors";
// import { URL_WHATSAPP } from "../settings";
import ENDPOINTS from "../constants/endpoints";

const { Panel } = Collapse;
const { Paragraph, Title } = Typography;
const { Search } = Input;

const StyledSection = styled(Section)`
  padding-top: 48px;
  padding-bottom: 48px;
  background: #f5f5f5;
`;

const StyledCollapse = styled(Collapse)`
  background: white;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  margin-top: 24px;

  .ant-collapse-item {
    border-bottom: 1px solid #f0f0f0;
  }

  .ant-collapse-header {
    font-weight: 600;
    font-size: 16px;
    padding: 16px 24px !important;
  }

  .ant-collapse-content-box {
    padding: 16px 24px;
  }
`;

const IntroSection = styled.div`
  text-align: center;
  margin-bottom: 48px;
`;

const IntroTitle = styled(Title)`
  color: ${GREE_1};
  margin-bottom: 16px !important;
`;

const IntroText = styled(Paragraph)`
  font-size: 16px;
  color: #666;
  max-width: 700px;
  margin: 0 auto 24px;
  line-height: 1.6;
`;

const WhatsAppButton = styled(Button)`
  background: #25D366;
  border: none;
  color: white;
  font-weight: bold;
  height: 44px;
  padding: 0 32px;
  border-radius: 22px;
  box-shadow: 0 2px 8px rgba(37, 211, 102, 0.3);
  transition: all 0.3s ease;
  font-size: 16px;

  &:hover {
    background: #20BA5A;
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(37, 211, 102, 0.5);
    color: white;
  }

  &:active {
    transform: translateY(0);
  }

  .anticon {
    font-size: 20px;
  }
`;

const SearchWrapper = styled.div`
  max-width: 600px;
  margin: 0 auto 32px;
`;

const EmptyState = styled.div`
  text-align: center;
  padding: 48px 24px;
  background: white;
  border-radius: 8px;
  color: #999;
`;

export default function FAQ() {
    const [searchTerm, setSearchTerm] = useState('');

    return (
        <>
            <SubBanner title={'Perguntas Frequentes'} />
            <StyledSection>
                <ContentContainer>
                    <IntroSection>
                        <IntroTitle level={3}>Tire suas dúvidas</IntroTitle>
                        <IntroText>
                            Aqui você encontra respostas para as perguntas mais comuns sobre nossos serviços,
                            como se tornar um associado, atendimento médico, cannabis medicinal e muito mais.
                            Navegue pelas perguntas abaixo ou use o campo de busca para encontrar o que procura.
                        </IntroText>
                        <IntroText>
                            Não encontrou a resposta que procurava? Nossa equipe está pronta para ajudar!
                        </IntroText>
                        {/*<WhatsAppButton*/}
                        {/*    icon={<WhatsAppOutlined />}*/}
                        {/*    size="large"*/}
                        {/*    onClick={() => window.open(URL_WHATSAPP, '_blank')}*/}
                        {/*>*/}
                        {/*    Fale Conosco no WhatsApp*/}
                        {/*</WhatsAppButton>*/}
                    </IntroSection>

                    <SearchWrapper>
                        <Search
                            placeholder="Buscar perguntas..."
                            size="large"
                            prefix={<SearchOutlined />}
                            allowClear
                            onSearch={(value) => setSearchTerm(value)}
                        />
                    </SearchWrapper>

                    <PaginatedList
                        request={{
                            url: ENDPOINTS.FAQ_LIST_PUBLIC,
                            params: { search: searchTerm },
                            dependence: [searchTerm]
                        }}
                        emptyComponent={
                            <EmptyState>
                                {searchTerm
                                    ? 'Nenhuma pergunta encontrada com esses termos'
                                    : 'Nenhuma pergunta disponível no momento'}
                            </EmptyState>
                        }
                    >
                        {(faqs) => (
                            <StyledCollapse
                                accordion
                                expandIconPosition="end"
                            >
                                {faqs.map((faq) => (
                                    <Panel
                                        header={faq.question}
                                        key={faq.id}
                                    >
                                        <Paragraph>{faq.answer}</Paragraph>
                                    </Panel>
                                ))}
                            </StyledCollapse>
                        )}
                    </PaginatedList>
                </ContentContainer>
            </StyledSection>
        </>
    );
}
